module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_11",
    attrs: {
      "id": "calibre_pb_2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('i', {
    staticClass: "calibre1"
  }, [_vm._v("I Found Him on the Internet")]), _vm._v(" is a collection of three long love stories between people later in life, the first of which won an internet prize. Published by the Bialik Publishing House, Jerusalem, it sold extensively and received glowing reviews.")]), _vm._v(" "), _c('p', {
    staticClass: "block_13"
  }, [_vm._v("Aloma Halter is a writer, poet, translator, and editor. She was born in London, studied literature at the University of Cambridge, and came to Israel in 1980. Halter has translated four novels by Aharon Appelfeld into English, including The Story of a Life, and edited many novels which include recipients of the Koret Prize and a National Jewish Book Award. She lives in Jerusalem with her two daughters.")]), _vm._v(" "), _c('p', {
    staticClass: "block_14",
    attrs: {
      "id": "calibre_pb_3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2baadc4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_003.vue
// module id = 72
// module chunks = 0